/**
 * Rywale, z którymi wołający ma już żywy, umówiony termin.
 *
 * Backend odrzuca drugą akceptację tego samego meczu wyjątkiem ALREADY_AGREED
 * (TournamentProposalService.acceptProposal), ale robi to dopiero po wyborze slotu i kortu —
 * gracz przechodzi całą ścieżkę, żeby usłyszeć „anuluj poprzedni". Front używa tego zbioru,
 * żeby w ogóle nie pokazywać „Przyjmij" w takiej sytuacji.
 *
 * Predykat „żywy termin" jest celowo taki sam jak serwerowy: koniec OKNA propozycji
 * (proposedDate + proposedEndTime) w przyszłości. Nie godzina samego meczu (slotStartTime + 2 h),
 * bo backend blokuje po oknie — gdyby front liczył inaczej, przycisk pojawiałby się dokładnie
 * w tych przypadkach, w których serwer i tak odmówi.
 */

function windowEnd(proposal) {
    if (!proposal.proposedDate || !proposal.proposedEndTime) return null;
    const parsed = new Date(`${proposal.proposedDate}T${proposal.proposedEndTime}`);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function arrangedOpponentIds(proposals, myParticipantId, now = new Date()) {
    const ids = new Set();
    if (!proposals || myParticipantId == null) return ids;

    for (const proposal of proposals) {
        if (proposal.status !== 'ACCEPTED') continue;

        const end = windowEnd(proposal);
        if (end === null || end <= now) continue;

        let opponentId = null;
        if (proposal.proposerParticipantId === myParticipantId) {
            opponentId = proposal.accepterParticipantId;
        } else if (proposal.accepterParticipantId === myParticipantId) {
            opponentId = proposal.proposerParticipantId;
        }

        if (opponentId != null) ids.add(opponentId);
    }
    return ids;
}
